
import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

let makeCall = function (runnable, route) {
  return new Promise((resolve, reject) => {
    axios.get(route)
      .then(response => {
        runnable(response)
        resolve(response)
      })
      .catch((error) => {
        var errors = error.response.data
        if (errors['Unauthorized']) {
          router.push({name: 'App'})
        }
        reject(error.response.status)
        reject(new Error('Error retrieving' + route))
      })
  })
}

let makePost = function (postData, route, errorCallback, dontCombineErrors, forceArrayBuf) {
  return new Promise((resolve, reject) => {
    axios.post(route, postData, forceArrayBuf ? {responseType: 'arraybuffer'} : {})
      .then(response => { resolve(response) })
      .catch((error) => {
        if (error.response.status === 422 && errorCallback) {
          var errors = error.response.data.errors
          if (forceArrayBuf) {
            var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data))
            errors = JSON.parse(decodedString).errors
          }
          if (errors['Unauthorized']) {
            router.push({name: 'App'})
          }
          if (dontCombineErrors) {
            errorCallback(errors)
          } else {
            errorCallback([].concat.apply([], Object.values(errors)))
          }
        }
        reject(error.response.status)
      })
  })
}

let makeDelete = function (route, errorCallback) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      url: route
    })
      .then(response => { resolve(response) })
      .catch((error) => {
        var errors = error.response.data.errors
        if (errors['Unauthorized']) {
          router.push({name: 'App'})
        }
        errorCallback(errors)
        reject(error.response.status)
      })
  })
}

let makeDownload = function (postData, route, errorCallback) {
  return new Promise((resolve, reject) => {
    axios.post(route, postData, {
      responseType: 'blob'
    }).then(response => { resolve(response) })
      .catch((error) => {
        var reader = new FileReader()
        reader.onloadend = function (e) {
          var errors = e.srcElement.result
          errors = JSON.parse(errors)
          if (errors['Unauthorized']) {
            router.push({name: 'App'})
          }
          errorCallback(errors)
          reject(error.response.status)
        }
        reader.readAsText(error.response.data)
      })
  })
}

export default Object.assign(new Vuex.Store({
  state: {
    usStatesList: null,
    constants: null,
    summary: null,
    charity: {
      charityList: []
    },
    buyers: {
      buyersList: []
    },
    towingCompanies: {
      towingCompaniesList: []
    }
  },
  getters: {
  },
  mutations: {
    setConstants (state, data) {
      state.constants = data
      state.usStatesList = data.us_states_list
      state.charity.charityStatus = data.charity.charity_status
      state.charity.charityStatusAll = data.charity.charity_status.slice(0)
      state.charity.charityStatusAll.unshift({
        'label': 'All Charity Statuses',
        'value': 'all'
      })
      state.charity.negativeBalance = data.charity.negative_balance
      state.buyers.buyerStatus = data.buyers.buyer_status
    },
    setSummary (state, data) {
      state.summary = data
      state.charities = {}
      state.charities.withAll = state.summary.charities.slice(0)
      state.charities.withAll.unshift({
        'label': 'All Charities',
        'value': 'all'
      })
      state.charities.states = state.summary.charity_states.slice(0)
      state.charities.states.unshift({
        'label': 'All Charity States',
        'value': 'all'
      })
      state.charities.cities = state.summary.charity_cities.slice(0)
      state.charities.cities.unshift({
        'label': 'All Charity Cities',
        'value': 'all'
      })
      state.charities.zips = state.summary.charity_zips.slice(0)
      state.charities.zips.unshift({
        'label': 'All Charity Zip Codes',
        'value': 'all'
      })
      state.referralSources = {}
      state.referralSources.withAll = state.summary.referral_sources.slice(0)
      state.referralSources.withAll.unshift({
        'label': 'All Referral Sources',
        'value': 'all'
      })
      state.buyers.buyersList = data.buyers
      state.buyers.withAll = state.summary.buyers.slice(0)
      state.buyers.withAll.unshift({
        'label': 'All Buyers',
        'value': 'all'
      })
      state.towingCompanies.towingCompaniesList = data.towing_companies
      state.towingCompanies.withAll = state.summary.towing_companies.slice(0)
      state.towingCompanies.withAll.unshift({
        'label': 'All Towing Companies',
        'value': 'all'
      })
      state.charity.proceedsRateId = data.tiered_procceds_rate
      state.charity.proceedsRateId.push({
        label: 'Fixed',
        value: 'fixed'
      })
    }
  },
  actions: {
    syncConstants ({ commit }) {
      return new Promise((resolve, reject) => {
        if (this.state.constants) {
          resolve()
        } else {
          axios.get('/api/v1/constants')
            .then(response => {
              commit('setConstants', response.data)
              resolve()
            })
            .catch(e => {
              reject(new Error('Error retrieving constants'))
            })
        }
      })
    },
    syncSummary ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/summary')
          .then(response => {
            commit('setSummary', response.data)
            resolve()
          })
          .catch(e => {
            reject(new Error('Error retrieving summary'))
          })
      })
    }
  }
}), {
  functions: {
    newuser: {
      newUserInitialRegister (postData, errorCallback) {
        return makePost(postData, '/api/auth/userInitialRegister', errorCallback)
      },
      newUserRegister (postData, errorCallback) {
        return makePost(postData, '/api/auth/userRegister', errorCallback, true)
      },
      newProspectUserInitial (postData, errorCallback) {
        return makePost(postData, '/api/auth/prospectUserInitial', errorCallback)
      },
      newProspectUser (postData, errorCallback) {
        return makePost(postData, '/api/auth/prospectUser', errorCallback)
      },
    },
    formportal: {
      donorInitialLogin (postData, errorCallback) {
        return makePost(postData, '/api/v1/forms/donorInitialLogin', errorCallback, true)
      },
      donorLogin (postData, errorCallback) {
        return makeDownload(postData, '/api/v1/forms/donorLogin', errorCallback, true)
      }
    },
    buyers: {
      buyerTable (runnable) {
        return makeCall(runnable, '/api/v1/buyers/buyerTable')
      },
      getBuyer (buyerId, runnable) {
        return makeCall(runnable, '/api/v1/buyers/' + buyerId)
      },
      updateBuyer (buyerId, postData, errorCallback) {
        return makePost(postData, '/api/v1/buyers/' + buyerId, errorCallback, true)
      },
      createBuyer (postData, errorCallback) {
        return makePost(postData, '/api/v1/buyers', errorCallback, true)
      }
    },
    charity: {
      createCharity (postData, errorCallback) {
        return makePost(postData, '/api/v1/charities', errorCallback, true)
      },
      createCharityProspect (postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/prospect', errorCallback, true)
      },
      updateCharity (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/' + charityId, errorCallback, true)
      },
      charityTable (runnable, filterArray = null, filter = null) {
        if (filterArray) return makeCall(runnable, '/api/v1/charities/charityTable?filter=' + filterArray + '&text=' + encodeURIComponent(filter))
        else return makeCall(runnable, '/api/v1/charities/charityTable?text=' + encodeURIComponent(filter))
      },
      getContactLog (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/notesAndContactsTable')
      },
      getSources (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/referralSources')
      },
      getSourcesTable (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/sourceTable')
      },
      getProceeds (charityId, runnable, years) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/proceedsTable?years=' + years)
      },
      getUnpaidProceeds (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/unpaidProceedsTable')
      },
      makePayment (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charityPayments/' + charityId, errorCallback, true)
      },
      getPaymentDetail (paymentId, runnable) {
        return makeCall(runnable, '/api/v1/charityPayments/' + paymentId)
      },
      downloadPaymentCSV (paymentId, errorCallback) {
        return makeDownload(paymentId, '/api/v1/charityPayments/paymentCSV', errorCallback)
      },
      getVehicles (charityId, filter = null, runnable, filterArray, years) {
        if (filter) return makeCall(runnable, '/api/v1/charities/' + charityId + '/vehicleTable?filter=' + filterArray + '&years=' + years + '&text=' + encodeURIComponent(filter))
        else return makeCall(runnable, '/api/v1/charities/' + charityId + '/vehicleTable?filter=' + filterArray + '&years=' + years)
      },
      getVehicleYears (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/vehicleTable/years')
      },
      getCharity (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId)
      },
      getCharityFullForm (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/fullFormData')
      },
      addNote (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/' + charityId + '/addNote', errorCallback, true)
      },
      addContact (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/' + charityId + '/addContact', errorCallback, true)
      },
      uploadAgreement (charityId) {
        return '/api/v1/charities/' + charityId + '/uploadAgreement'
      },
      uploadAgreementChunked (charityId) {
        return '/api/v1/charities/' + charityId + '/uploadAgreementChunked'
      },
      downloadAgreement (charityId, errorCallback) {
        return makeDownload({}, '/api/v1/charities/' + charityId + '/downloadAgreement', errorCallback)
      },
      uploadLogo (charityId) {
        return '/api/v1/charities/' + charityId + '/uploadLogo'
      },
      displayLogo (charityId) {
        return '/api/v1/charities/' + charityId + '/logo?' + new Date().getTime()
      },
      downloadVehiclesCSV (vehicleIds, errorCallback) {
        return makeDownload(vehicleIds, '/api/v1/charities/vehiclesCSV', errorCallback)
      },
      getCharityWidgetDetails (charityId, runnable) {
        return makeCall(runnable, '/api/v1/charities/' + charityId + '/widget-details')
      },
      updateWidgetColors (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/' + charityId + '/widget-details', errorCallback, true)
      },
      updateAnalytics (charityId, postData, errorCallback) {
        return makePost(postData, '/api/v1/charities/' + charityId + '/analytics', errorCallback, true)
      },
    },
    preview: {
      getCharity (runnable) {
        return makeCall(runnable, '/api/v1/preview')
      },
      getProceeds (runnable) {
        return makeCall(runnable, '/api/v1/preview/proceedsTable')
      },
      getVehicles (runnable) {
        return makeCall(runnable, '/api/v1/preview/vehicleTable')
      },
      downloadVehiclesCSV (vehicleIds, errorCallback) {
        return makeDownload(vehicleIds, '/api/v1/preview/vehiclesCSV', errorCallback)
      },
      getPaymentDetail (paymentId, runnable) {
        return makeCall(runnable, '/api/v1/preview/payment/' + paymentId)
      },
      downloadPaymentCSV (paymentId, errorCallback) {
        return makeDownload(paymentId, '/api/v1/preview/paymentCSV', errorCallback)
      },
    },
    tieredProceedsRate: {
      createTieredProccedsRate (postData, errorCallback) {
        return makePost(postData, '/api/v1/tieredProceedsRates', errorCallback, true)
      }
    },
    towingCompanies: {
      towingCompaniesTable (runnable) {
        return makeCall(runnable, '/api/v1/towingCompanies/towingCompaniesTable')
      },
      getUnpaidProceeds (towingCompanyId, runnable) {
        return makeCall(runnable, '/api/v1/towingCompanies/' + towingCompanyId + '/unpaidProceedsTable')
      },
      makePayment (towingCompanyId, postData, errorCallback) {
        return makePost(postData, '/api/v1/towingPayments/' + towingCompanyId, errorCallback, true)
      },
      getPaymentDetail (paymentId, runnable) {
        return makeCall(runnable, '/api/v1/towingPayments/' + paymentId)
      },
      downloadPaymentCSV (paymentId, errorCallback) {
        return makeDownload(paymentId, '/api/v1/towingPayments/paymentCSV', errorCallback)
      },
      getProceeds (towingCompanyId, runnable) {
        return makeCall(runnable, '/api/v1/towingCompanies/' + towingCompanyId + '/paymentTable')
      },
      getTowingCompany (towingCompanyId, runnable) {
        return makeCall(runnable, '/api/v1/towingCompanies/' + towingCompanyId)
      },
      updateTowingCompany (towingCompanyId, postData, errorCallback) {
        return makePost(postData, '/api/v1/towingCompanies/' + towingCompanyId, errorCallback, true)
      },
      createTowingCompany (postData, errorCallback) {
        return makePost(postData, '/api/v1/towingCompanies', errorCallback, true)
      }
    },
    sources: {
      sourceTable (runnable) {
        return makeCall(runnable, '/api/v1/sources/sourcesTable')
      },
      getSource (sourceId, runnable) {
        return makeCall(runnable, '/api/v1/sources/' + sourceId)
      },
      editSource (sourceId, postData, errorCallback) {
        return makePost(postData, '/api/v1/sources/' + sourceId, errorCallback, true)
      },
      deleteSource (sourceId, errorCallback) {
        return makeDelete('/api/v1/sources/' + sourceId + '/delete', errorCallback)
      },
      createSource (postData, errorCallback) {
        return makePost(postData, '/api/v1/sources', errorCallback, true)
      }
    },
    vehicles: {
      getDashboardData (runnable) {
        return makeCall(runnable, '/api/v1/vehicles/dashboard')
      },
      vehiclesTable (runnable, filterArray = null, filter = null) {
        if (filterArray) return makeCall(runnable, '/api/v1/vehicles/vehiclesTable?filter=' + filterArray + '&text=' + encodeURIComponent(filter))
        else return makeCall(runnable, '/api/v1/vehicles/vehiclesTable?text=' + encodeURIComponent(filter))
      },
      vinInfo (postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/vin', errorCallback, true)
      },
      createVehicle (postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/create', errorCallback, true)
      },
      callBackDonation (url, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + url, errorCallback, true)
      },
      getVehicleDonation (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId)
      },
      getNotes (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/notesTable')
      },
      addNote (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/addNote', errorCallback, true)
      },
      getChangeLogTable (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/changeLogTable')
      },
      getVehicleDonorInfo (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/donorInfo')
      },
      editVehicleDonorInfo (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/donorInfo', errorCallback, true)
      },
      updateVehicleProcessingInfo (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/processingInfo', errorCallback, true)
      },
      getVehicleProcessingInfo (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/processingInfo')
      },
      getVehicleDispositionInfo (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/dispositionInfo')
      },
      updateVehicleDispositionInfo (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/dispositionInfo', errorCallback, true)
      },
      getVehicleDetailInfo (vehicleId, runnable) {
        return makeCall(runnable, '/api/v1/vehicles/' + vehicleId + '/detailInfo')
      },
      editVehicleDetailInfo (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/detailInfo', errorCallback, true)
      },
      sendBuyerVehicleInfo (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/sendBuyerVehicleInfo', errorCallback, true)
      },
      sendTowRequest (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/sendTowRequest', errorCallback, true)
      },
      downloadTowRequest (vehicleId, postData, errorCallback) {
        return makeDownload(postData, '/api/v1/vehicles/' + vehicleId + '/downloadTowRequest', errorCallback)
      },
      sendVdr (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/sendVdr', errorCallback, true)
      },
      downloadVdr (vehicleId, postData, errorCallback) {
        return makeDownload(postData, '/api/v1/vehicles/' + vehicleId + '/downloadVdr', errorCallback)
      },
      send1098 (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/send1098', errorCallback, true)
      },
      download1098 (vehicleId, errorCallback) {
        return makeDownload({}, '/api/v1/vehicles/' + vehicleId + '/download1098', errorCallback)
      },
      sendVdc (vehicleId, postData, errorCallback) {
        return makePost(postData, '/api/v1/vehicles/' + vehicleId + '/sendVdc', errorCallback, true)
      },
      downloadVdc (vehicleId, postData, errorCallback) {
        return makeDownload(postData, '/api/v1/vehicles/' + vehicleId + '/downloadVdc', errorCallback)
      },
      printDocuments (vehicleId, postData, errorCallback) {
        return makeDownload(postData, '/api/v1/vehicles/' + vehicleId + '/printDocuments', errorCallback)
      }
    },
    users: {
      usersTable (runnable) {
        return makeCall(runnable, '/api/v1/users/usersTable')
      },
      getUser (userId, runnable) {
        return makeCall(runnable, '/api/v1/users/' + userId)
      },
      editUser (userId, postData, errorCallback) {
        return makePost(postData, '/api/v1/users/' + userId, errorCallback, true)
      },
      createUser (postData, errorCallback) {
        return makePost(postData, '/api/v1/users', errorCallback, true)
      },
      deactivateUser (userId, errorCallback) {
        return makeDelete('/api/v1/users/' + userId + '/delete', errorCallback)
      },
      reactivateUser (userId, postData, errorCallback) {
        return makePost({}, '/api/v1/users/' + userId + '/restore', errorCallback)
      },
      resendRegistration (userId, errorCallback) {
        return makePost({}, '/api/v1/users/' + userId + '/resend', errorCallback)
      }
    },
    emails: {
      emailsTable (runnable) {
        return makeCall(runnable, '/api/v1/emails/emailsTable')
      },
      getEmail (emailId, runnable) {
        return makeCall(runnable, '/api/v1/emails/' + emailId)
      },
      editEmail (emailId, postData, errorCallback) {
        return makePost(postData, '/api/v1/emails/' + emailId, errorCallback)
      }
    },
    payables: {
      getDashboardData (runnable) {
        return makeCall(runnable, '/api/v1/payables/dashboard')
      },
      charityPayablesTable (runnable) {
        return makeCall(runnable, '/api/v1/payables/charityPayablesTable')
      },
      towingCompaniesPayablesTable (runnable) {
        return makeCall(runnable, '/api/v1/payables/towingCompaniesPayablesTable')
      },
    },
    reports: {
      makeReport (postData, errorCallback) {
        return makePost(postData, '/api/v1/reports/makeReport', errorCallback, true, true)
      },
      makeCharityReport (postData, errorCallback) {
        return makePost(postData, '/api/v1/reports/makeCharityReport', errorCallback, true, true)
      },
      updateSavedTemplate (id, postData, errorCallback) {
        return makePost(postData, '/api/v1/reports/saved-template/' + id, errorCallback)
      },
      deleteSavedTemplate (id, errorCallback) {
        return makeDelete('/api/v1/reports/saved-template/' + id, errorCallback)
      },
      fetchIrsYearData (year, runnable) {
        return makeCall(runnable, '/api/v1/reports/irs/' + year)
      },
      downloadIrsReport (id, errorCallback) {
        return makeDownload(id, '/api/v1/reports/irs/download', errorCallback)
      },
      generateIrsReport (year, errorCallback) {
        return makePost(year, '/api/v1/reports/irs/generate', errorCallback)
      },
    }
  },
  storage: {
    charities_status: {},
    charities_filters: [],
    vehicles_status: null,
    vehicles_filters: null,
  }
})



// WEBPACK FOOTER //
// ./src/store.js